// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"b44582f3","453":"246327d5"}[chunkId] + ".chunk.js";
};